import type { Answer, SourceDocument } from "@/components/types";

/**
 * Enriches source documents with quotes and answer reference flags from Answer data
 * @param answer - The Answer object containing sections with document references
 * @param sourceDocuments - Array of SourceDocument objects to enrich
 * @returns Array of enriched SourceDocument objects
 */
export const enrichSourceDocuments = (
  answer: Answer,
  sourceDocuments: SourceDocument[]
): SourceDocument[] => {
  // Create a map of document_id to quote for quick lookup
  const documentQuoteMap = new Map<string, string>();
  
  // Extract quotes from all sections
  answer?.sections?.forEach(section => {
    if (section.type === "legal_framework") {
      section?.items?.forEach(item => {
        if ('document_id' in item && 'quote' in item) {
          documentQuoteMap.set(item.document_id, item.quote);
        }
      });
    } else if (section.type === "case_analysis") {
      section?.items?.forEach(item => {
        if ('document_id' in item && 'quote' in item) {
          documentQuoteMap.set(item.document_id, item.quote);
        }
      });
    }
  });

  // Enrich source documents with quotes and answer reference flags
  return sourceDocuments?.map(doc => {
    const quote = documentQuoteMap.get(doc._id);
    const isAnswerRef = quote !== undefined;
    
    return {
      ...doc,
      metadata: {
        ...doc.metadata,
        quote: quote || doc.metadata.quote,
        isAnswerRef: isAnswerRef || doc.metadata.isAnswerRef || false
      }
    };
  });
};
